import React, { ComponentProps, ReactNode } from 'react';
import {
    Item,
    CartProvider as ReactCartProvider,
    useCart as reactUseCart,
} from 'react-use-cart';

import { IBook } from './Books';

export function CartProvider({
    children,
    ...props
}: {
    children: ReactNode;
} & ComponentProps<typeof ReactCartProvider>): JSX.Element {
    return <ReactCartProvider {...props}>{children}</ReactCartProvider>;
}

export function useCart(): Omit<ReturnType<typeof reactUseCart>, 'items'> & {
    items: (IBook & Item)[];
} {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return reactUseCart();
}
